import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { previewFileApiV1ToolbarFileFileIdPreviewGet } from '#/shared/api/generated/shipment/theCargoShipment'
import { getApiErrorDetail } from '#/shared/lib/api/error-handler'
import { toast } from '#/shared/ui/sonner'

const REVOKE_DELAY_MS = 60_000

export function useOpenToolbarFile() {
  const { t } = useTranslation()
  return useCallback(
    async (fileId: string) => {
      try {
        const response =
          await previewFileApiV1ToolbarFileFileIdPreviewGet(fileId)
        const blob = response.data
        const url = URL.createObjectURL(blob)
        window.open(url, '_blank', 'noopener,noreferrer')
        window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS)
      } catch (error) {
        toast.error(
          getApiErrorDetail(error) ?? t('shipmentToolbar.create.error'),
        )
      }
    },
    [t],
  )
}
